import * as types from '../action/actionTypes';
import initialState from './initialState';


export default class BuildingAndMembersReducer {
  static BuildingReducer(state = initialState.Buildings, action) {
        switch (action.type) {
            case types.GET_BUILDINGS_LIST_SUCCESSFULL: return {
                BuildingsList: action.getResponse,
            };
            
            default : return state; 
        }   
    }

    static MembersReducer(state = initialState.Members, action) {
    switch (action.type) {
        case types.GET_MEMBERS_LIST_SUCCESSFULL: return {
            MembersList: action.getResponse,
        };
        default : return state; 
    }   

}

static BuildingDetailsReducer(state = initialState.BuildingDetails, action) {
    switch (action.type) {
        case types.GET_BUILDINGS_DETAILS_SUCCESSFULL: return {
            BuildingsDetailsList: action.getResponse,
        };
        default: return state;
    }
}
    static BuildingFamilyReducer(state = initialState.FamilyDetails, action){
        switch (action.type) {
            case types.GET_FAMILY_LIST_SUCCESSFULL: return {
                FamilyDetailsList: action.getResponse,
            };
            
            default : return state; 
        }
    }

    static BuildingEquipmentObjectsReducer(state = initialState.EquipmentObjectDetails, action){
        switch (action.type) {
            case types.GET_EQUIPMENT_OBJECT_LIST_SUCCESSFULL: return {
                EquipmentObjectDetailsList: action.getResponse,
            };
            
            default : return state; 
        }
    }

    static BuildingPointsReducer(state = initialState.BuildingPointsDetails, action){
        switch (action.type) {
            case types.GET_POINTS_LIST_SUCCESSFULL: return {
                BuildingPointsDetailsList: action.getResponse,
            };
            
            default : return state; 
        }
    }

    static BuildingEquipmentPointsReducer(state = initialState.BuildingEquipmentPointsDetails, action){
        switch (action.type) {
            case types.GET_BUILDING_POINTS_LIST_SUCCESSFULL: return {
                BuildingEquipmentPointsDetailsList: action.getResponse,
            };
            
            default : return state; 
        }
    }

    static BuildingUnitsReducer(state = initialState.BuildingUnitsDetails, action){
        switch (action.type) {
            case types.GET_UNITS_LIST_SUCCESSFULL: return {
                BuildingUnitsDetailsList: action.getResponse,
            };
            
            default : return state; 
        }
    }

    static BuildingDatalogObjectsReducer(state = initialState.BuildingDatalogObjectsDetails, action){
        switch(action.type){
            case types.GET_DATALOG_METERS_OBJECTS: return{
                BuildingDatalogObjectDetailsList: action.getResponse,
            };
            default : return state;
        }
    }
}
